import { Outlet } from 'react-router-dom-v5-compat';
import { AuthenticatedPageLayout } from 'src/components/organisms/Common/AuthenticatedPageLayout/AuthenticatedPageLayout';
import { ReportingNavbar } from 'src/components/organisms/Navbar/ReportingNavbar';

export const ReporterHubPageLayout = () => {
  return (
    <AuthenticatedPageLayout navbar={<ReportingNavbar />}>
      <Outlet />
    </AuthenticatedPageLayout>
  );
};
